<template>
  <div>

    <div class="masthead">
      <div class="body">
        <h1>BINDER</h1>
      </div>
    </div>

    <section v-if="ready">
      <assignment-list :assignments="assignments">
        <h2 slot="headline">{{assignmentsCompleted}}:</h2>
        <div class="empty" slot="empty">
          <h2>You have not completed any assignments.</h2>
        </div>
      </assignment-list>
    </section>

  </div>
</template>

<script>

  import AssignmentList from "@/components/AssignmentList"

  export default {
    name: 'Binder',
    routeConfig: {
      name: "binder", path: "/binder", meta: { transHeader: true }
    },
    metaInfo: {
      title: "Binder"
    },
    components: { AssignmentList },
    data () {
      // see comment in routes/Assignments/index.vue
      let criteria = {
        limit: 100,
        where: {
          state: 'closed'
        }
      }
      return {
        ready: false,
        mastheadVideoLoaded: false,
        assignmentsCompleted: "",
        assignments: this.$store.filter('userAssignments', criteria),
        assignmentsPromise: this.$store.findAll('userAssignments', criteria)
      }
    },
    created () {
      this.assignmentsPromise.then((assignments) => {
        this.ready = true
        this.assignments = assignments
        if (!this.assignments.length) {
          this.assignmentsCompleted = ""
        } else if (this.assignments.length == 1) {
          this.assignmentsCompleted = "You've completed 1 assignment"
        } else {
          this.assignmentsCompleted = `You've completed ${this.assignments.length} assignments`
        }
      })
    },
  }
</script>

<style lang="scss" scoped>

  @import "~globals";

  .masthead {
    display:flex; align-items:center; height:40vh; position:relative; overflow:hidden; background-size:cover;background-image:url('/static/sb-hero-binder1.jpg');
    &::before {
      @include position(absolute, 0 0 0 0);
      background:$color-white; z-index:2; opacity:.3; content:'';
    }
    .body {
      @include container;
      width:100%; position:relative; z-index:3;
    }
    h1 {
      @include font-size(xxlarge, $headline: true); margin-top: 5rem;
    }
    h2 {
      @include font-size(medium, $headline:true); margin-top: 2rem;
    }
    h1, h2 {
      text-align:center;
      mark {
        color:$color-primary;
      }
    }
  }

  section {
    @include container;
    margin-top:4rem;
    h2 {
      @include font-size(xlarge, $headline: true);
      margin-bottom:4rem;
    }
  }

  .empty {
    height:50vh; display:flex; align-items:center; justify-content:center; border:solid .1rem $color-gray-lighter;
    h2 {
      margin-bottom:0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/routes/Binder/index.vue